import script from "./LatestTransactionsCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatestTransactionsCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./LatestTransactionsCarousel.vue?vue&type=style&index=0&id=2a645967&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a645967"]])

export default __exports__